var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviationWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 652 652",
    viewBox: "0 0 652 652",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#232c54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m382.4 353.6 18 26.1h.1v-26.1h3v30.9h-3.3l-18.1-26.2v26.2h-3v-30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.6 353.6v2.5h-18.4v11.1h17.3v2.6h-17.3v12.2h18.6v2.5h-21.6v-30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.4 353.6v2.5h-10.8v28.4h-3v-28.4h-10.7v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.9 353.6 7 27h.1l7.6-27h3.6l7.6 27h.1l7.1-27h2.9l-8.5 30.9h-3.1l-7.9-27.7h-.1l-7.8 27.7h-3.2l-8.6-30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.7 374c.4 1.6 1.1 3.1 2.1 4.4.9 1.3 2.1 2.3 3.6 3.1s3.2 1.2 5.3 1.2 3.8-.4 5.3-1.2 2.7-1.8 3.6-3.1 1.6-2.7 2.1-4.4c.4-1.6.7-3.3.7-5s-.2-3.4-.7-5-1.1-3.1-2.1-4.4c-.9-1.3-2.1-2.3-3.6-3.1s-3.2-1.2-5.3-1.2-3.8.4-5.3 1.2-2.7 1.8-3.6 3.1-1.6 2.7-2.1 4.4c-.4 1.6-.7 3.3-.7 5s.3 3.4.7 5zm-2.7-11.1c.6-1.9 1.5-3.6 2.7-5.1s2.7-2.7 4.6-3.6c1.8-.9 4-1.3 6.4-1.3s4.6.4 6.4 1.3 3.3 2.1 4.6 3.6c1.2 1.5 2.1 3.2 2.7 5.1s.9 4 .9 6.1-.3 4.2-.9 6.1-1.5 3.6-2.7 5.1-2.7 2.6-4.6 3.5c-1.8.9-3.9 1.3-6.4 1.3-2.4 0-4.6-.4-6.4-1.3s-3.4-2.1-4.6-3.5c-1.2-1.5-2.1-3.2-2.7-5.1s-.9-4-.9-6.1.3-4.1.9-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.4 368.2c.9 0 1.7-.1 2.6-.4.8-.3 1.5-.7 2.1-1.2s1.1-1.1 1.5-1.9c.4-.7.5-1.6.5-2.5 0-1.9-.5-3.4-1.6-4.5s-2.8-1.6-5-1.6h-11v12.2h10.9zm.2-14.6c1.3 0 2.5.2 3.6.5s2.1.8 3 1.4c.9.7 1.5 1.5 2 2.5s.8 2.2.8 3.6c0 2-.5 3.7-1.5 5.1s-2.5 2.4-4.5 2.8v.1c1 .1 1.9.4 2.5.8.7.4 1.2.9 1.6 1.5s.7 1.3.9 2.1.3 1.7.4 2.6c0 .5.1 1.2.1 1.9 0 .8.1 1.5.2 2.3s.2 1.5.4 2.2.4 1.2.8 1.6h-3.3c-.2-.3-.3-.6-.4-1.1-.1-.4-.2-.9-.2-1.3s-.1-.9-.1-1.3-.1-.8-.1-1.1c-.1-1.1-.2-2.2-.3-3.3s-.4-2.1-.8-2.9c-.4-.9-1-1.5-1.8-2.1-.8-.5-1.9-.8-3.3-.7h-11.2v13.7h-2.9v-30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.9 353.6v16.6l18-16.6h4l-13.9 12.7 14.5 18.2h-3.8l-12.9-16.1-5.9 5.5v10.6h-3v-30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409 338.8-9-36.1h-.1l-8.8 36.1h-11.9l-14-53h11.7l8.4 36.1h.1l9.2-36.1h10.9l9.1 36.5h.1l8.7-36.5h11.5l-14.3 53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.4 285.8v9.8h-28v11.4h25.7v9h-25.7v13h28.6v9.8h-40.2v-53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.1 285.8v9.8h-28v11.4h25.7v9h-25.7v13h28.6v9.8h-40.2v-53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.8 285.8v22l20.7-22h14.6l-20.7 20.9 11.3 16-1 5.2 1.8-4.1 10.6 15h-14.7l-15.9-23.8-6.7 6.7v17.1h-11.7v-53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.7 318.3-6.7-19.4h-.1l-6.9 19.4zm-.7-32.5 19.8 53h-12.1l-4-11.8h-19.8l-4.2 11.8h-11.7l20.1-53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82 338.8-17.2-53h12l11.8 37.3h.1l12-37.3h12l-17.6 53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.6 338.8h11.6v-53h-11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.2 318.3-6.7-19.4h-.2l-6.9 19.4zm-.7-32.5 19.8 53h-12.1l-4-11.8h-19.8l-4.2 11.8h-11.7l20.1-53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.4 295.6v-9.8h43.4v9.8h-15.8v43.2h-11.7v-43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.2 338.8h11.7v-53h-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.7 319c.5 2.1 1.3 4 2.5 5.7 1.1 1.7 2.6 3 4.5 4 1.8 1 4.1 1.5 6.7 1.5s4.9-.5 6.7-1.5 3.3-2.4 4.5-4c1.1-1.7 2-3.6 2.5-5.7s.8-4.3.8-6.5c0-2.3-.3-4.6-.8-6.8s-1.4-4.1-2.5-5.8-2.6-3.1-4.5-4.1c-1.8-1-4.1-1.5-6.7-1.5s-4.9.5-6.7 1.5-3.3 2.4-4.5 4.1c-1.1 1.7-2 3.6-2.5 5.8s-.8 4.4-.8 6.8c0 2.3.3 4.4.8 6.5zm-10.7-17.5c1.2-3.4 2.9-6.3 5.1-8.9 2.2-2.5 5-4.5 8.2-5.9s6.9-2.2 11-2.2 7.8.7 11 2.2c3.2 1.4 5.9 3.4 8.2 5.9 2.2 2.5 3.9 5.5 5.1 8.9s1.8 7.1 1.8 11-.6 7.5-1.8 10.8-2.9 6.2-5.1 8.7-5 4.4-8.2 5.8-6.9 2.1-11 2.1-7.7-.7-11-2.1c-3.2-1.4-6-3.3-8.2-5.8s-3.9-5.4-5.1-8.7-1.8-6.9-1.8-10.8c.1-3.9.7-7.6 1.8-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.4 285.8 22.1 35.6h.2v-35.6h10.9v53h-11.7l-22-35.5h-.2v35.5h-10.9v-53z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m556.9 279.6 63.1-22.3-51.3 70.6 19.2-48.3z",
    fill: "#d42f30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationWeek);
export default __webpack_public_path__ + "static/media/aviation-week.94b79ca608da588fa1e5eeb458856f99.svg";
export { ForwardRef as ReactComponent };